export default {

    welcome: {
        preTitle: "Bienvenue à la",
        title: "TOMBOLA CocaCola",
        subtitle: "Jouez et tentez de gagner des lots exclusifs!",
    },
    next: "Suivant",
    phone: {
        label: "Numéro de Téléphone",
        inputPlaceholder: "Votre numéro de téléphone",
        description: "Entre ton numéro pour jouer et récupérer ton cadeau.",
        error: {
            invalid: "Numéro de téléphone invalide. Veuillez réessayer.",
            missing_phone: "Numéro de téléphone invalide. Veuillez réessayer."
        },

        participate: "Participer"
    },

    error_msg: "Erreur",
    photo: {
        label: "Téléversez votre photo",
        subtitle: "Montrez-nous votre bouteille de Coca-Cola récemment ouverte !",
        uploadButton: "Téléverser",
        instructions: "Assurez-vous que la photo est claire et lisible",
        successMessage: "Photo reçue avec succès !",
        remove: "Retirer",
        error: {
            noPhoto: "Veuillez téléverser une photo pour continuer.",
            noCaptureDate: "La photo doit être prise avec un appareil photo. Veuillez téléverser une autre photo.",
            photoOld: "Veuillez téléverser une photo récente.",
            invalid: "Photo invalide.",
            invalid_link: "Lien invalide ou expiré.",
            photo_too_big: "La photo dépasse la taille maximale autorisée.",
            compressionFailed: "Échec de la compression de la photo.",

            // 🔥 Added backend-key equivalents
            missing_photo: "Veuillez ajouter une photo.",
            invalid_photo_format: "Format de photo invalide. Utilisez JPG ou PNG.",
            photo_failed_to_upload: "Le téléversement de la photo a échoué.",
            invalid_photo_content: "Photo de bouteille invalide. Veuillez prendre une photo claire de votre bouteille de marque Coca-Cola ouverte.",
            invalid_brand: "Photo de bouteille invalide. Veuillez prendre une photo claire de votre bouteille de marque Coca-Cola ouverte.",
            not_a_bottle: "Photo de bouteille invalide. Veuillez prendre une photo claire de votre bouteille de marque Coca-Cola ouverte.",
            cap_not_removed: "Photo de bouteille invalide. Veuillez prendre une photo claire de votre bouteille de marque Coca-Cola ouverte.",
            low_confidence_detection: "Photo de bouteille invalide. Veuillez prendre une photo claire de votre bouteille de marque Coca-Cola ouverte.",
            verification_failed: "La verification de la photo a échouée , Veuillez reprendre une photo claire de votre bouteille de marque Coca-Cola ouverte."

        }
    },
    scanBottle: {
        loading: "Analyse de votre bouteille..."
    },
    camera: {
        title: "Caméra Coca-Cola",
        description: "Prenez une photo claire de votre bouteille Coca-Cola ouverte.",
        permission_message: "Veuillez autoriser l’accès à la caméra.",
        open_button: "Ouvrir la caméra",
        capture: "Prendre la photo",
        preview: "Aperçu",
        save: "Enregistrer",
        retry: "Réessayer"
    },
    spin: {
        label: "Tourner la Roue",
        subtitle: "Tentez votre chance pour gagner des Points ",
        spinButton: "Tourner",
        winMessage: "Félicitations ! Vous avez gagné :",
        loseMessage: "Dommage, essayez encore !",
        instructions: "Appuyez sur le bouton pour tenter votre chance"
    },
    celebration: {
        title: "Félicitations !",
        subtitle: "Vous avez gagné",
        physical_message: "Nous vous contacterons pour vous remettre votre prix.",
        digital_message: "Téléchargez l'application Gifty pour récupérer votre cadeau.",
        download_app_button: "Télécharger Gifty App",
    }
};